"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wearable = void 0;
const validation_1 = require("../../validation");
const rarity_1 = require("../../dapps/rarity");
const base_wearable_1 = require("./base-wearable");
/** @alpha */
var Wearable;
(function (Wearable) {
    Wearable.schema = {
        ...base_wearable_1.BaseWearable.schema,
        properties: {
            ...base_wearable_1.BaseWearable.schema.properties,
            collectionAddress: {
                type: 'string'
            },
            rarity: rarity_1.Rarity.schema
        },
        required: [...base_wearable_1.BaseWearable.schema.required, 'collectionAddress', 'rarity']
    };
    const schemaValidator = (0, validation_1.generateValidator)(Wearable.schema);
    Wearable.validate = (wearable) => schemaValidator(wearable) &&
        base_wearable_1.BaseWearable.validateDuplicatedLocales(wearable.descriptions) &&
        base_wearable_1.BaseWearable.validateDuplicatedLocales(wearable.names);
})(Wearable = exports.Wearable || (exports.Wearable = {}));
//# sourceMappingURL=wearable.js.map